import Page from "components/page/Page";
import PageTitle from "components/pageTitle/PageTitle";
import PageWrapper from "components/pageWrapper/PageWrapper";
import { memo } from "react";
import Helmet from "components/headHelmet/HeadHelmet";
import SmartLink from "components/smartLink/SmartLink";
import { useTranslation } from "react-i18next";

const TermsAndConditionsPage = () => {
  const { t } = useTranslation("terms");
  return (
    <>
      <Helmet>
        <title>{t("metaTitle")}</title>
      </Helmet>
      <Page collapsedView={true}>
        <PageWrapper>
          <PageTitle>{t("pageTitle")}</PageTitle>
          <p>{t("intro")}</p>
          <p>
            <b>{t("useOfWebsite.heading")}</b>
          </p>
          <p>{t("useOfWebsite.eligibility")}</p>
          <p>{t("useOfWebsite.license")}</p>
          <p>{t("useOfWebsite.conduct")}</p>
          <p>
            <b>{t("thirdPartyLinks.heading")}</b>
          </p>
          <p>{t("thirdPartyLinks.body")}</p>
          <p>
            <b>{t("intellectualProperty.heading")}</b>
          </p>
          <p>{t("intellectualProperty.ownership")}</p>
          <p>{t("intellectualProperty.restrictions")}</p>
          <p>
            <b>{t("disclaimer.heading")}</b>
          </p>
          <p>{t("disclaimer.body")}</p>
          <p>
            <b>{t("liability.heading")}</b>
          </p>
          <p>{t("liability.body")}</p>
          <p>
            <b>{t("indemnification.heading")}</b>
          </p>
          <p>{t("indemnification.body")}</p>
          <p>
            <b>{t("privacyPolicy.heading")}</b>
          </p>
          <p>{t("privacyPolicy.body")}</p>
          <p>
            <b>{t("modifications.heading")}</b>
          </p>
          <p>{t("modifications.body")}</p>
          <p>
            <b>{t("contactUs.heading")}</b>
          </p>
          <p>
            {t("contactUs.body")}{" "}
            <SmartLink to={"/contact"}>{t("contactUs.contactLink")}</SmartLink>.
          </p>
          <p>{t("agreement")}</p>
        </PageWrapper>
      </Page>
    </>
  );
};

export default memo(TermsAndConditionsPage);
